export function buildFileName(parts: Array<string | null | undefined>, fallback: string): string {
  const name = parts.filter((part) => typeof part === 'string' && part.trim().length)
    .map((part) => (part as string).trim())
    .join('_');
  return name || fallback;
}

export function downloadBlobAsFile(blob: Blob, fileName: string): void {
  const safeName = fileName && fileName.trim().length ? fileName.trim() : 'download.bin';
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = safeName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
